export default __webpack_public_path__ + "static/media/logo_nop.d77ee2c9.png";